var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-small-item',{attrs:{"prop":_vm.prop,"required":_vm.required,"rules":_vm.computedRules,"validate-status":_vm.validateStatus,"show-message":false,"field":_vm.field}},[_c('el-form',_vm._g(_vm._b({ref:"form",attrs:{"model":_vm.computedModel,"rules":_vm.formRules}},'el-form',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }